import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";

import { __API_URL__ } from "../SERVER_URL";

const moveAppDocument = async ({ documentId, mediaType, photoSessionId, typeId }) => {
  const token = localStorage.getItem("token");
  const res = await axios.post(
    `${__API_URL__}/api/patient/patient/app_documents/${documentId}/move/`,
    { media_type: mediaType, photo_session_id: photoSessionId, type_id: typeId },
    { headers: { Authorization: `Token ${token}` } }
  );
  return res.data;
};

const useMoveAppDocumentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: moveAppDocument,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["patient-app-documents"] });
      toast.success("Document moved successfully");
    },
    onError: (error) => {
      const msg = error?.response?.data?.message || "Failed to move document";
      toast.error(msg);
    },
  });
};

export default useMoveAppDocumentMutation;
